export function formatStorageFromKB(kb: number): string {
  if (!Number.isFinite(kb)) return "0 KB";

  const absKB = Math.abs(kb);
  const KB_IN_MB = 1024;
  const KB_IN_GB = 1024 * 1024;

  const formatValue = (value: number): string =>
    Number.isInteger(value)
      ? value.toString()
      : Number(value.toFixed(2)).toString();

  if (absKB >= KB_IN_GB) {
    const gb = absKB / KB_IN_GB;
    return `${formatValue(gb)} GB`;
  } else if (absKB >= KB_IN_MB) {
    const mb = absKB / KB_IN_MB;
    return `${formatValue(mb)} MB`;
  }

  return `${formatValue(absKB)} KB`;
}
